import { get, post } from "../GenericServices";

const ProjectCostPlan = {
  getProjectCostPlan: (id) => {
    return get(`project/${id}/project-cost-plan`);
  },
  getProjectCostPlanActivity: (id, projectTaskId) => {
    return get(`project/${id}/project-cost-plan/project-task/${projectTaskId}`);
  },
  projectCostPlanExport: (id) => {
    return get(`project/${id}/project-cost-plan/export`, {}, "arraybuffer"); // To download xlsx I must set responseType = arraybuffer);
  },
  saveProjectCostPlan: (id, projectTaskId, body) => {
    return post(`project/${id}/project-cost-plan/${projectTaskId}/save`, body);
  },
  projectCostPlanTotal: (id) => {
    return get(`project/${id}/project-cost-plan/total`);
  },
  reopenProjectCostPlan: (id) => {
    return post(`project/${id}/project-cost-plan/reopen-plan`);
  },
  zeroProjectCostPlan: (id, projectTaskId) => {
    return post(`project/${id}/project-cost-plan/${projectTaskId}/reset-cost-plan`);
  },
};

export default ProjectCostPlan;
